import { render, staticRenderFns } from "./InfoNintendo.vue?vue&type=template&id=56221190"
import script from "./InfoNintendo.vue?vue&type=script&lang=js"
export * from "./InfoNintendo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports